const buildDirectional = (key: string[][], handlerNames: string[]) => {
  const result: Record<string, string> = {};
  key.forEach((directionSet) => {
    directionSet.forEach((key, index) => {
      result[key] = handlerNames[index];
    });
  });
  return result;
};

export default {
  cancel: {
    Escape: "cancel",
    Backspace: "cancel",
  },
  advance: {
    " ": "advance",
    Enter: "advance",
  },
  graphMovement: {
    ...buildDirectional(
      [
        ["w", "a", "s", "d"],
        ["k", "h", "j", "l"],
        ["ArrowUp", "ArrowLeft", "ArrowDown", "ArrowRight"],
      ],
      ["up", "left", "down", "right"]
    ),
    ...buildDirectional(
      [
        ["W", "A", "S", "D"],
        ["K", "H", "J", "L"],
        ["SArrowUp", "SArrowLeft", "SArrowDown", "SArrowRight"],
      ],
      ["sUp", "sLeft", "sDown", "sRight"]
    ),
  },
  baseActions: {
    v: "look",
  },
  playerActions: {
    "\\": "cheat",
    ".": "wait",
  },
  DEBUG_MENUS: {
    p: "DEBUG_MAP",
  },
} as const;
